import type { TOC } from '@ember/component/template-only';

interface DashboardGridLayoutSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

/*
 * The shell owns the page gutter (DESIGN.md § Page width and gutter), so this
 * grid carries vertical rhythm only — its own `p-*` stacked a second inset on
 * top of it and pushed the tiles off the alignment every other page keeps.
 */
const DashboardGridLayoutComponent: TOC<DashboardGridLayoutSignature> = <template>
  <div
    class="w-full py-4 grid grid-rows-[fit-content(100%)] gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center"
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export default DashboardGridLayoutComponent;
